import { HttpInterceptorFn, HttpResponse, HttpStatusCode } from "@angular/common/http";
import { delay, of } from "rxjs";

import { APIs } from "@azm/core/constants/api-names";
import { getEnvironmentApiBaseUrl } from "@azm/core/enums/environment";
import { IApiResponse } from "@azm/core/interfaces/response";
import { createMockLoginResponse, MOCK_PERMISSIONS, MOCK_SIDEBAR } from "@azm/core/mocks";

import { environment } from "@azm/environments/environment";

const MOCK_LATENCY_MS = 250;
const NOT_MOCKED = Symbol("not-mocked");

function wrap<T>(data: T): IApiResponse<T> {
	return { data, message: "", success: true, statusCode: HttpStatusCode.Ok, errors: null, brokenRules: [] };
}

function resolveMock(method: string, path: string, body: unknown): unknown {
	if (method === "POST" && path === `auth/${APIs.auth.loginAsInternalUser}`) {
		const adUserName = (body as { adUserName?: string } | null)?.adUserName;
		return createMockLoginResponse(adUserName ?? undefined);
	}
	if (method === "POST" && path === `auth/${APIs.auth.refreshToken}`) return createMockLoginResponse();
	if (method === "GET" && path === `auth/${APIs.auth.permissions}`) return MOCK_PERMISSIONS;
	if (method === "GET" && path === "sidebar") return MOCK_SIDEBAR;
	if (method === "GET" && path.startsWith("announcement/")) return { data: [], totalCount: 0 };
	if (method === "POST" && path.startsWith("announcement/read/")) return true;
	return NOT_MOCKED;
}

export const mockApiInterceptor: HttpInterceptorFn = (req, next) => {
	if (!environment.useMockApi) return next(req);

	const apiPrefix = `${getEnvironmentApiBaseUrl(environment)}api/`;
	if (!req.url.startsWith(apiPrefix)) return next(req);

	const path = req.url.slice(apiPrefix.length).split("?")[0] ?? "";
	const data = resolveMock(req.method, path, req.body);
	if (data === NOT_MOCKED) return next(req);

	return of(new HttpResponse({ status: HttpStatusCode.Ok, url: req.url, body: wrap(data) })).pipe(delay(MOCK_LATENCY_MS));
};
